import React, { useState } from 'react'
import { Box } from '@mui/joy'
import { IconButton } from '../../assets'
import { Text } from '../Typography'
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter, GridToolbarDensitySelector } from '@mui/x-data-grid'
import { RecipeSelector } from '.'
import JSONPretty from 'react-json-pretty';
import { useSettingsContext } from 'src/mtska-frontend-app-scaffolding'

const ListToolbar = ({ leftButtons = [], rightButtons = [], isFullScreen, setIsFullScreen, dataProviderName, handleApplyRecipe, total, totalLabel, apiRef, setSettingsKey, isManaged }) => {

    const [settingsOpened, setSettingsOpened] = useState(false)

    const handleSettingsToggle = () => {
        setSettingsOpened(!settingsOpened)
    }

    const { settings } = useSettingsContext(dataProviderName);

    return (
        <GridToolbarContainer className="list-toolbar" sx={{ justifyContent: 'space-between' }}>
            <Box className="list-toolbar-secondary list-toolbar-filter">
                {total !== undefined ? (
                    <Text level="body-sm">
                        {totalLabel} <span style={{ color: '#1976d2' }}>{total}</span>
                    </Text>
                ) : (
                    <>
                        {<GridToolbarQuickFilter placeholder="Search..." sx={{ marginLeft: "auto" }} />}
                        {leftButtons.map((v, k) => <Box key={k}>{v}</Box>)}
                    </>
                )}
            </Box>
            {total === undefined && (
                <Box className="list-toolbar-primary" sx={{ display: "flex", gap: "5px" }}>
                    {settingsOpened ? (
                        <GridToolbarContainer>
                            {/* <RecipeSelector dataProviderName={dataProviderName} handleApplyRecipe={handleApplyRecipe} apiRef={apiRef} setSettingsKey={setSettingsKey}/> */}
                            <GridToolbarColumnsButton />
                            <GridToolbarFilterButton />
                            <GridToolbarDensitySelector
                                slotProps={{ tooltip: { title: 'Change density' } }}
                            />
                        </GridToolbarContainer>
                    ) : (
                        rightButtons.map((v, k) => <Box key={k}>{v}</Box>)
                    )}
                    <IconButton onClick={handleSettingsToggle} className="list-toolbar-activator" icon="faEllipsisVertical" style={'color:#9FA6AD'} />
                    {
                        !isManaged && <IconButton icon={isFullScreen ? 'faCompress' : 'faExpand'} style={'color:#9FA6AD'} onClick={() => setIsFullScreen(!isFullScreen)} />
                    }
                    
                </Box>
            )}
        </GridToolbarContainer>
    );
}

export default ListToolbar
